import React, { useEffect, useState, useRef } from "react";
import Print from "@arcgis/core/widgets/Print";
import esriRequest from "@arcgis/core/request.js";
import { useTranslation } from "react-i18next";
import { showAlert } from "../../../../utils/Helpers";
import "./DefaultPrint.css";
import LegendLayer from "@arcgis/core/rest/support/LegendLayer.js";
import { MdOutlineKeyboardBackspace } from "react-icons/md";

import {
  validateEmail,
  sanitizeInput,
} from "../../../../utils/HelperFunctions";
let Layout_Options = [];
let Format_Options = [];
let printedFiles = []
const PrintMap = (props) => {
  const { printRef } = props;
  const { t } = useTranslation();
  const { mapview } = props;
  const [selectedFormat, setSelectedFormat] = React.useState("PDF");
  const [selectedLayout, setSelectedLayout] = React.useState("");
  const showEmailForm = useRef(false);
  const showEmailButtons = useRef(false)
  const [loading, showLoading1] = useState(false);
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [previewFile, setPreviewFile] = useState(null);
  const [printisDisabled, setprintIsDisabled] = useState(false);
  const [enablePrintButton, setEnablePrintButton] = useState(false);
  // const [printedfiles, setPrintedFiles] = React.useState([]);
  const [title, setTitle] = useState(""); // Add this line to track title
  const [titleError, setTitleError] = useState(""); // Add this for title validation error
  const titleRef = useRef(title);
  const titleErrorRef = useRef(titleError);
  useEffect(() => {
    titleRef.current = title;
  }, [title]);

  useEffect(() => {
    titleErrorRef.current = titleError;
  }, [titleError]);

  const Previewcontrols = (e) => {

    if (selectedFormat === "PDF") {
      // console.log('preview pdf', e.mapImg)
      setPreviewFile((prevPreviewFile) => ({
        ...prevPreviewFile,
        pdf: e.mapImg,
        img: null,
      }));
    } else if (window.imagecheck.includes(selectedFormat)) {
      setPreviewFile((prevPreviewFile) => ({
        ...prevPreviewFile,
        img: e.mapImg,
        pdf: null,
      }));
    }
  };
  const showLoading = (e) => {
    if (e === true) {
      showLoading1(e);
      setEnablePrintButton(false);
      setprintIsDisabled(true);
    } else {
      showLoading1(e);
      setEnablePrintButton(true);
      setprintIsDisabled(false);
    }
  };

  useEffect(() => {
    // Inject the CSS class into the document head
    const style = document.createElement('style');
    style.innerHTML = `
      .hidden-important {
        display: none !important;
      }
     .text-danger {
      color: #dc3545;
      font-size: 0.875rem;
    }
    .title-error {
      margin-top: 0.25rem;
      padding-left: 0.3rem;
    }
    .titleInput.error {
      border-color: #dc3545 !important;
    }
    `;
    document.head.appendChild(style);
  }, []);
  const sendEmail = async (e) => {
    e.preventDefault();

    if (!emailFormValidation()) {
      return;
    }

    try {
      showLoading(true);
      const sanitizedSubject = sanitizeInput(subject);
      const sanitizedMessage = message ? sanitizeInput(message) : message;
      const payload = {
        to: email,
        subject: sanitizedSubject,
        message: sanitizedMessage,
        templatePath: "PrintMap_UserNotification",
        fileUrl: previewFile.pdf ?? previewFile.img,
      };
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Auth/sendMail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        const errorText = await response.json();
        throw new Error(`${response.status}: ${errorText.message}`);
      }
      showAlert(t("SentEmail"), "success");
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (error) {
      if (error.name === "TypeError" && error.message === "Failed to fetch") {
        showAlert(t("networkError"), "error");
      } else {
        showAlert(t("errorEmail"), "error");
      }
      // console.log("Error sending email:", error);
    } finally {
      showLoading(false);
    }
  };
  useEffect(() => {
    if (!email || !subject) {
      return;
    }
    /**Validate inputs whenever it changes */
    emailFormValidation();
  }, [email, subject]);

  const emailFormValidation = () => {
    const newErrors = {};
    const emailVal = validateEmail(t, email);
    if (emailVal !== "") {
      newErrors.emailTo = emailVal;
    }
    if (subject === "") {
      newErrors.emailSub = t("requiredField");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;

  };
  useEffect(() => {
    const fetchPrintOptions = async () => {
      const options = {
        query: { f: "json" },
        responseType: "json",
      };
      const response = await esriRequest(window.printTaskURL, options)
      const Layout_Template = response.data.parameters.find(
        // (param) => param.name === t("Layout_Template")/**no need to add localization for this conditional check */
        (param) =>
          param.name ===
          "Layout_Template" /**revised code - added 10102024(saxina) */
      );
      const Format_Template = response.data.parameters.find(
        (param) => param.name === "Format"
      );

      if (!Layout_Template || !Format_Template) {
        showAlert(t("noLayouts"), "error");
        return;
      }

      const excludedTemplates = ["A0 Ar Landscape", "A0 En Landscape"];
      const layoutItems = Layout_Template.choiceList
        // .filter((item) => window.requiredLayouts.includes(item))
        .filter((item) => !excludedTemplates.includes(item))
        .map((item) => ({
          name: item,
          id: item,
        }));

      const formatItems = window.requiredformats
        //  .filter((item) => window.requiredformats.includes(item))
        .map((item) => ({
          name: item,
          id: item,
        }));
      Layout_Options = layoutItems;
      Format_Options = formatItems;
      setSelectedLayout(layoutItems[0]?.id);
    };
    fetchPrintOptions();
  }, []);

  useEffect(() => {
    if (mapview && printRef && printRef?.current) {
      try {
        let legendLayers = [];
        mapview.map.allLayers.forEach(layer => {
          // if (layer.portalItem?.id === "0b9de48542ad4bc694d0204307843343" ||
          //   layer.url?.includes("BaseMapEng_LightGray_WM") ||
          //   layer.type === "tile" || layer.type === "basemap") {
          //   if (layer.sublayers) {
          //     layer.sublayers.forEach(sublayer => {
          //       sublayer.legendEnabled = false; // Enable legend for each sublayer
          //     });
          //   }
          //   layer.legendEnabled = false; // Enable legend for the layer
          // }

          if (
            layer.type === "basemap" ||
            layer.type === "tile"
          ) return;
         
        
          if (!layer.visible) return;
         
        
          // if (layer.type === "map-image" && layer.sublayers) {
         
          //   const collectVisibleSublayers = (sublayers) => {
          //     let ids = [];
          //     sublayers.forEach(sl => {
          //       if (sl.visible) {
          //         ids.push(sl.id);
          //       }
          //       if (sl.sublayers) {
          //         ids = ids.concat(collectVisibleSublayers(sl.sublayers));
          //       }
          //     });
          //     return ids;
          //   };
         
          //   const visibleSubLayerIds = collectVisibleSublayers(layer.sublayers);
         
          //   if (visibleSubLayerIds.length > 0) {
          //     legendLayers.push({
          //       layerId: layer.id,
          //       subLayerIds: visibleSubLayerIds.sort((a,b)=>a-b)
          //     });
          //   }
          // }
         
        
          // else {
          //   legendLayers.push({
          //     layerId: layer.id
          //   });
          // }

          legendLayers.push({
            layerId: layer.id
          });
        });
        console.log("FINAL legendLayers:", legendLayers);
        mapview.map.basemap.baseLayers.forEach(layer => {
          layer.legendEnabled = false;
        });

        mapview.map.basemap.referenceLayers.forEach(layer => {
          layer.legendEnabled = false;
        });
        try {
          const printwidget = new Print({
            view: mapview,
            container: printRef.current,
            printServiceUrl: window.printTaskURL,
            allowedFormats: 'all',
            allowedLayouts: 'all',
            templateOptions: {
              title: "My Print",
              format: selectedFormat,
              layout: selectedLayout,
              legendLayers,
            }
          });

          printwidget.on("complete", function (results) {
            // The results are stored in the results object
            console.log("Results of the print: ", results.link);


            // setPrintedFiles((prevFiles) => [...prevFiles, results.link]);
            printedFiles.push(results.link);
            Previewcontrols({ mapImg: results.link.url, isPrint: true });
            printwidget.viewModel.showPrintAreaEnabled = false
          });
          printwidget.on("error", function () {
            // Find all exported file containers

          });
        }
        catch (error) {
          console.error("Error creating print widget:", error);
        }


        // Observe for changes in the printRef container to remove the "Map Only" tab when it appears
        const observer = new MutationObserver(() => {
          const liElement = document.getElementById('printDiv__mapOnlyTab');
          if (liElement) {
            liElement.remove(); // Remove the <li> element directly
            observer.disconnect(); // Stop observing once the element is removed
          }
        });

        observer.observe(printRef.current, { childList: true, subtree: true });

        return () => {
          const currentPrintRef = printRef.current;
          if (currentPrintRef) {
            currentPrintRef.bind?.destroy();
          }
        };
      } catch (error) {
        console.error("Error initializing print widget:", error);
      }
    }
  }, [mapview]);

  const styleTabs = () => {

    const tabList = document.querySelector(".esri-print__layout-tab-list");
    if (tabList) {
      tabList.style.backgroundColor = "transparent";
      tabList.style.bottom = "0";
      tabList.style.gap = "0.8rem";
      tabList.querySelectorAll(".esri-print__layout-tab").forEach(tab => {
        tab.style.fontFamily = "var(--font-primary-regular)";
        tab.style.fontSize = "0.75rem";
        tab.style.color = "#2d787f";
        tab.style.padding = "0.4375rem 1.25rem";
        tab.style.backgroundColor = "#ebf6ff";
        tab.style.whiteSpace = "nowrap";
        tab.style.borderRadius = "0.3125rem";
        tab.style.border = "none";
        tab.style.textAlign = "center";
        // tab.style.marginRight = "0.625rem";

        if (tab.getAttribute("aria-selected") === "true") {
          tab.style.color = "var(--light-text)";
          tab.style.backgroundColor = "var(--link)";
        }
      });
    }

    const printDiv = document.getElementById("printDiv");
    if (printDiv) {
      const loader = printDiv.querySelector(".esri-print__loader");
      const finalContent = printDiv.querySelector(".esri-print__advanced-options-section");

      const screenWidth = window.innerWidth;

      if (screenWidth >= 330 && screenWidth <= 767) {
        printDiv.style.maxHeight = "calc(65vh - 7rem)";
      } else {
        printDiv.style.maxHeight = "calc(70vh - 5rem)";
      }

      printDiv.style.width = "100%";
      printDiv.style.minHeight = "unset!important";
      printDiv.style.overflow = "auto";
      // printDiv.style.display = "inline-block";
      printDiv.style.borderRadius = "8px";
      if (loader && !finalContent) {
        printDiv.classList.add("loading"); // adds flex center
        printDiv.style.display = "flex";
      }

      if (!loader && finalContent) {
        printDiv.classList.remove("loading");
        printDiv.style.display = "inline-block";
      }
    }

    const esriPrintContent = document.querySelector(".esri-print__content");
    if (esriPrintContent) {
      esriPrintContent.style.backgroundColor = "transparent";
    }

    const loaderPrint = document.querySelector("#printDiv .esri-print__loader");
    if (loaderPrint) {
      loaderPrint.style.height = "100%";
    }

    const esriPrintLayputContent = document.querySelector(".esri-print__layout-section");
    if (esriPrintLayputContent) {
      esriPrintLayputContent.style.padding = "1rem 0.3rem";
    }

    const titleInputEsr = document.getElementById("titleInput");
    if (titleInputEsr) {
      titleInputEsr.style.height = "2.5rem";
      titleInputEsr.style.borderRadius = "0.375rem";
    }

    const layoutSelectPrint = document.getElementById("layoutSelect");
    if (layoutSelectPrint) {
      layoutSelectPrint.style.height = "2.5rem";
      layoutSelectPrint.style.borderRadius = "0.375rem";
      layoutSelectPrint.style.background = "var(--forPrintEsriSelect)";
      layoutSelectPrint.style.color = "var(--forPrintColorSelect)";
    }

    const formatSelectPrint = document.getElementById("formatSelect");
    if (formatSelectPrint) {
      formatSelectPrint.style.height = "2.5rem";
      formatSelectPrint.style.borderRadius = "0.375rem";
      formatSelectPrint.style.background = "var(--forPrintEsriSelect)";
      formatSelectPrint.style.color = "var(--forPrintColorSelect)";
    }

    const esriPrintAdvancedContent = document.querySelector(".esri-print__advanced-options-section");
    if (esriPrintAdvancedContent) {
      esriPrintAdvancedContent.style.background = "var(--forPrintAdvancedSelect)";
      esriPrintAdvancedContent.style.color = "var(--forPrintColorSelect)";
      esriPrintAdvancedContent.style.borderRadius = "0.375rem";
    }

    const esriPrintExportTil = document.querySelector(".esri-print__export-title");
    if (esriPrintExportTil) {
      esriPrintExportTil.style.color = "var(--forPrintColorSelect)";
    }

    const esriPrintExportlinks = document.querySelectorAll(".esri-print__exported-file-link-title");
    esriPrintExportlinks.forEach(link => {
      link.style.color = "var(--printEsriDespo)";
      link.style.fontSize = "0.875rem";
      link.style.fontFamily = "Omnes Medium";
    });

    const esriPrintExportdescrip = document.querySelectorAll(".esri-print__exported-file-link-description");
    esriPrintExportdescrip.forEach(link => {
      link.style.color = "var(--printEsriDespo)";
      link.style.fontFamily = "Omnes Regular";
    });

    const exportIconEsro = document.querySelectorAll(".esri-print__exported-file");
    exportIconEsro.forEach(link => {
      link.style.color = "var(--printEsriDespo)";
      // for Tooltip 
      const icon = link.querySelector('calcite-icon[icon="launch"]');
      if (icon) {
        icon.setAttribute('title', 'Preview');
      }
    });

    const calciteActions = document.querySelectorAll('.esri-print__export-panel-container calcite-action');

    calciteActions.forEach(action => {
      // Check if action has shadow root
      if (action.shadowRoot) {

        const interactionContainer = action.shadowRoot.querySelector('.interaction-container');
        if (interactionContainer) {

          const button = interactionContainer.querySelector('button');
          if (button) {
            button.style.color = 'var(--printEsriDespo)';
            button.style.setProperty('--calcite-ui-text-1', 'var(--printEsriDespo)');

            // Add tooltip

            const icon = button.querySelector('calcite-icon');
            if (icon) {
              const iconName = icon.getAttribute('icon');
              // Add the tooltip title
              if (iconName === 'x') {
                button.title = 'Delete';
              }
              if (iconName === 'share') {
                button.title = 'Share';
              }
            }
          }
        }
      }
    });

  };

  const modifyContentWrapper = () => {
    const flowItems = document.querySelectorAll("calcite-flow-item");
    flowItems.forEach(item => {
      const shadow = item.shadowRoot;
      if (shadow) {
        const panel = shadow.querySelector("calcite-panel");
        if (panel && panel.shadowRoot) {
          const contentWrapper = panel.shadowRoot.querySelector(".content-wrapper");
          if (contentWrapper) {
            contentWrapper.style.backgroundColor = "var(--graphFillBg)";
            contentWrapper.style.overflow = "hidden";
            contentWrapper.style.padding = "1rem 0.7rem"
          }
        }
      }
    });
  };
  useEffect(() => {
    // Update error display whenever titleError changes
    const updateTitleErrorDisplay = () => {
      // For custom title input
      const titleInput = document.querySelector(".titleInput");
      if (titleInput) {
        titleInput.className = `titleInput ${titleError ? "error" : ""}`;
        titleInput.style.borderColor = titleError ? "#dc3545" : "#cccccc";
        const errorDiv = titleInput.nextElementSibling;
        if (errorDiv && errorDiv.className.includes("title-error")) {
          errorDiv.textContent = titleError;
        }
      }

      // For ArcGIS-provided title input
      const titleInputShadow = document.querySelector("calcite-input")?.shadowRoot?.querySelector(".wrapper");
      if (titleInputShadow) {
        const input = titleInputShadow.querySelector("input");
        const errorDiv = titleInputShadow.querySelector(".title-error");
        if (input) {
          input.style.borderColor = titleError ? "#dc3545" : "#cccccc";
        }
        if (errorDiv) {
          errorDiv.textContent = titleError;
        }
      }
    };

    updateTitleErrorDisplay();
  }, [titleError]);
  useEffect(() => {
    let timeout;

    const applyEsriStyling = () => {
      let legendLayers = [];
      const combobox = document.querySelector("calcite-combobox");
      const layoutdiv = document.querySelector("calcite-block");
      const button = document.querySelector("calcite-button");
      const titleinput = document.querySelector("calcite-input");
      const titleinputShadow = titleinput?.shadowRoot?.querySelector(".wrapper");
      const printPanel = document.querySelector(".esri-print__panel-container");
      const layouttab = document.querySelector("#printDiv__layoutContent");
      const legendEnabled = document.querySelector("calcite-checkbox");

      if (legendEnabled) {
        const operationalLayers = mapview.map.allLayers
          .filter(layer => layer.listMode !== "hide" && layer.visible)
          .filter(layer => layer.type !== "basemap")
          .filter(layer => !["BaseMapAra_LightGray_WM", "BaseMapAra_DarkGray_WM", "BaseMapEng_DarkGray_WM", "BaseMapEng_LightGray_WM"].includes(layer.title))
          .map(layer => ({
            id: layer.id,
            title: layer.title
          }));

        legendLayers = operationalLayers.map(layer => new LegendLayer({
          layerId: layer.id,
          title: layer.title
        }));

        legendEnabled.checked = operationalLayers.length > 0;
      }

      if (titleinputShadow) {
        if (titleinput.parentElement.innerText === "Title") {
          const titleinputtag = titleinputShadow.querySelector("input");
          titleinputtag.value = titleRef.current; // Use ref
          titleinputtag.style.border = "0.0625rem solid #cccccc;";
          titleinputtag.style.height = "40px";
          titleinputtag.style.borderRadius = "6px";

          titleinputtag.addEventListener("input", (e) => {
            setTitle(e.target.value);
            if (e.target.value.trim()) {
              setTitleError("");
            }
          });
          // // Add error message element right after the input
          // if (!titleinputShadow.querySelector(".title-error")) {
          //   const errorDiv = document.createElement("div");
          //   errorDiv.className = "title-error text-danger";
          //   errorDiv.style.fontSize = "0.875rem";
          //   errorDiv.style.marginTop = "0.25rem";
          //   titleinputShadow.appendChild(errorDiv);
          // }

          // // Update error message
          // const errorDiv = titleinputShadow.querySelector(".title-error");
          // errorDiv.textContent = titleErrorRef.current; // Use ref
          // titleinputtag.style.borderColor = titleError ? "#dc3545" : "#cccccc";

          const calciteLabel = titleinput.closest("calcite-label");

          if (calciteLabel && !calciteLabel.nextElementSibling?.classList.contains("title-error")) {
            // Create error div
            const errorDiv = document.createElement("div");
            errorDiv.className = "title-error text-danger";
            errorDiv.style.fontSize = "0.875rem";
            errorDiv.style.marginTop = "0.25rem";
            errorDiv.textContent = titleErrorRef.current; // Use ref

            // Insert error div right after <calcite-label>
            calciteLabel.parentNode.insertBefore(errorDiv, calciteLabel.nextSibling);
          }

          // Update error text and border style
          const existingErrorDiv = calciteLabel.nextElementSibling?.classList.contains("title-error")
            ? calciteLabel.nextElementSibling
            : null;

          if (existingErrorDiv) {
            existingErrorDiv.textContent = titleErrorRef.current;
          }

          titleinputtag.style.borderColor = titleError ? "#dc3545" : "#cccccc";
        }
        else {
          const titlediv = document.createElement("div");
          titlediv.className = "titleDiv";
          const titlelabel = document.createElement("label");
          titlelabel.className = "titleLabel";
          titlelabel.textContent = title || "Title";
          titlelabel.value = title
          titlediv.appendChild(titlelabel);
          const titleinput = document.createElement("input");
          titleinput.id = "titleInput";
          titleinput.className = `titleInput ${titleError ? "error" : ""}`;
          titleinput.placeholder = "Enter title";
          titleinput.style.border = "0.0625rem solid #cccccc;";
          titleinput.style.height = "40px";
          titleinput.value = titleRef.current; // U
          titleinput.onchange = (event) => {
            const selectedValue = event.target.value;
            // Update the print widget's title if printRef is available            
            if (printRef.current) {
              const printWidget = printRef.current.bind;
              if (printWidget) {
                printWidget.viewModel.templateOptions.title = selectedValue;
              }
            }
          };
          titleinput.addEventListener("input", (e) => {
            const newTitle = e.target.value;
            setTitle(newTitle); // Update React state
            localStorage.setItem("title", newTitle); // Sync to localStorage if needed
            setTitleError(newTitle.trim() ? "" : t("requiredField")); // Clear error if valid
          });
          const titleDiv = document.querySelector(".titleDiv");
          titlediv.appendChild(titleinput);

          // Add error message div
          const errorDiv = document.createElement("div");
          errorDiv.className = "title-error text-danger";
          errorDiv.style.fontSize = "0.875rem";
          errorDiv.style.marginTop = "0.25rem";
          errorDiv.textContent = titleErrorRef.current;
          titlediv.appendChild(errorDiv);

          if (!titleDiv) {
            if (layouttab) {
              printPanel.insertBefore(titlediv, printPanel.firstChild);
            }
          }

        }

      }
      if (combobox?.shadowRoot) {
        const wrapper = combobox.shadowRoot.querySelector(".wrapper");
        if (wrapper) {
          wrapper.style.border = "0.0625rem solid #cccccc;";
          wrapper.style.height = "40px";
          wrapper.style.borderRadius = "6px";
        }
      }

      if (layoutdiv) {
        const SelectElement = document.getElementById("layoutSelect");
        if (!SelectElement) {
          const layoutDiv = document.createElement("div");
          layoutDiv.className = "layoutDiv";
          const label = document.createElement("label");
          label.className = "layoutLabel";
          label.textContent = "Template";
          layoutDiv.appendChild(label);

          const layoutSelect = document.createElement("select");
          layoutSelect.id = "layoutSelect";
          layoutSelect.className = "layoutSelect";
          printRef.current.bind.viewModel.templateOptions.layout = Layout_Options[0]?.id;
          layoutSelect.onchange = (event) => {
            const selectedValue = event.target.value;
            // Update the print widget's layout if printRef is available
            setSelectedLayout(selectedValue);
            if (printRef.current) {
              const printWidget = printRef.current.bind;
              if (printWidget) {
                printWidget.viewModel.templateOptions.layout = selectedValue;
              }
            }
          };
          Layout_Options.forEach((option) => {
            const optionElement = document.createElement("option");
            optionElement.value = option.id;
            optionElement.textContent = option.name;
            if (option.id === selectedLayout) {
              optionElement.selected = true; // Set the selected option
            }
            layoutSelect.appendChild(optionElement);
          });
          layoutDiv.appendChild(layoutSelect);
          layoutdiv.parentElement.style.display = "none"; // Hide the original layout div
          layoutdiv.parentElement.parentElement.appendChild(layoutDiv);
        }
      }
      if (button?.shadowRoot) {
        const buttonContainer = button.shadowRoot.querySelector(".interaction-container");
        if (buttonContainer) {
          // Optionally apply styling to button container if needed
          // buttonContainer.style.someProperty = "value";
        }
      }
      if (printPanel) {
        const formatDiv = document.createElement("div");
        formatDiv.className = "formatDiv";
        const formatLabel = document.createElement("label");
        formatLabel.textContent = "File Format";
        formatLabel.className = "formatLabel";
        printRef.current.bind.viewModel.templateOptions.format = Format_Options[0]?.id;
        let selectElement = document.getElementById("formatSelect");
        if (!selectElement) {
          const tab = document.querySelector("#printDiv__exportedFilesTab");
          if (tab?.ariaSelected === "false") {
            selectElement = document.createElement("select");
            selectElement.id = "formatSelect";
            selectElement.className = "formatSelect";
            selectElement.onchange = (event) => {
              const selectedValue = event.target.value;
              // Update the print widget's format if printRef is available
              setSelectedFormat(selectedValue);
              if (printRef.current) {
                const printWidget = printRef.current.bind;
                if (printWidget) {
                  printWidget.viewModel.templateOptions.format = selectedValue.toLowerCase();
                }
              }
            };

            // Populate dropdown with format options
            Format_Options.forEach((option) => {
              const optionElement = document.createElement("option");
              optionElement.value = option.id;
              optionElement.textContent = option.name;
              if (option.id === selectedFormat) {
                optionElement.selected = true; // Set the selected option
              }
              selectElement.appendChild(optionElement);
            });

            // Append the custom select element to the print panel
            // printPanel.appendChild(selectElement);
            formatDiv.appendChild(formatLabel);
            formatDiv.appendChild(selectElement);
            if (combobox?.shadowRoot) {
              const wrapper = combobox.shadowRoot.querySelector(".wrapper");
              if (wrapper) {
                wrapper.style.borderColor = "white";
                wrapper.style.height = "40px";
                wrapper.style.borderRadius = "12px";
                combobox.parentElement.style.display = "none"
                combobox.parentElement.parentElement.appendChild(formatDiv)
              }
            }
          }
        }
      }
      // Update the print button text
      const printButton = document.querySelector(".esri-print__export-button");
      if (printButton) {
        if (printButton.textContent !== "Print") {
          printButton.textContent = "Print";
          printButton.disabled = false;
          const interactionContainer = printButton.shadowRoot.querySelector('.interaction-container');
          if (interactionContainer) {
            const button = interactionContainer.querySelector('button');
            if (button) {
              button.removeEventListener("click", handlePrintClick);
              button.addEventListener("click", handlePrintClick);

            }
            interactionContainer.querySelector('button').classList.add("print-button");
            interactionContainer.querySelector('button').style.background = "linear-gradient(270.18deg, #036068 -14.27%, #596451 47.55%, #1E7C87 76.37%, #4C7950 107.69%, #1199A8 147.31%)";
            interactionContainer.querySelector('button').style.color = "white";
            interactionContainer.querySelector('button').style.borderRadius = "12px";
            interactionContainer.querySelector('button').style.height = "40px";
            interactionContainer.querySelector('button').disabled = false;
          }
        }

      }
      const exportedFileDivs = document.querySelectorAll(".esri-print__exported-file");

      exportedFileDivs.forEach((fileDiv) => {
        const actions = fileDiv.parentElement.querySelectorAll("calcite-action");

        // Check if share button already exists
        const shareAlreadyExists = Array.from(actions).some(action => action.classList.contains("share-action"));
        if (shareAlreadyExists) return;

        const fileName = fileDiv.innerText.split("\n")[0];
        const matchingFile = printedFiles.find(file => file.formattedName === fileName);

        if (!matchingFile) {
          console.warn(`No matching printed file found for: ${fileName}`);
          return;
        }

        const fileUrl = matchingFile.url;
        const closeAction = actions[actions.length - 1];

        // Create the Share button
        const shareAction = document.createElement("calcite-action");
        shareAction.className = "share-action";
        shareAction.setAttribute("icon", "share");
        shareAction.setAttribute("text", "Share");
        shareAction.setAttribute("label", "Share exported file");
        shareAction.setAttribute("slot", "actions-end");
        shareAction.setAttribute("url", fileUrl);

        // Optional styling (only if shadowRoot is accessible, which might not be immediately after creation)
        setTimeout(() => {
          if (shareAction.shadowRoot) {
            const interactionContainer = shareAction.shadowRoot.querySelector('.interaction-container');
            if (interactionContainer) {
              const button = interactionContainer.querySelector('button');
              if (button) {
                // button.style.background = "linear-gradient(270.18deg, #036068 -14.27%, #596451 47.55%, #1E7C87 76.37%, #4C7950 107.69%, #1199A8 147.31%)";
                // button.style.color = "white";
                // button.style.borderRadius = "0.375rem";
              }
            }
          }
        }, 50); // Allow rendering first

        // Share click logic
        shareAction.addEventListener("click", async () => {
          if (showEmailForm.current) showEmailForm.current.style.display = 'block';
          if (printRef.current) printRef.current.style.display = 'none';
          if (showEmailButtons.current) showEmailButtons.current.classList.remove('hidden-important');
        });

        // Hook into close action cleanup
        if (closeAction) {
          closeAction.setAttribute("url", fileUrl);
          closeAction.addEventListener("click", () => {
            setTimeout(() => {
              printedFiles = printedFiles.filter(file => file.formattedName !== fileName);
            }, 0);
          });
          var isPrintExportError = false;
          if (printedFiles[0].error && printedFiles[0].error.message && printedFiles[0].error.message != "") {
            isPrintExportError = true;
          }
          if (!isPrintExportError) {
            closeAction.parentElement.insertBefore(shareAction, closeAction);
          }
        }
      });



    };


    const observer = new MutationObserver(() => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        applyEsriStyling();
        styleTabs();
        modifyContentWrapper();
      }, 100); // Debounce
    });

    const bodyNode = document.querySelector("body");
    if (bodyNode) {
      observer.observe(bodyNode, { childList: true, subtree: true });
    }

    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, []);
  const handlePrintClick = React.useCallback((e) => {
    if (!titleRef.current.trim()) { // Check the React state instead of localStorage
      e.preventDefault();
      e.stopPropagation();
      setTitleError(t("requiredField"));
      return;
    }

    // If validation passes, allow the print to proceed
  }, [title, t]);
  useEffect(() => {
    if (printRef && printRef.current?.bind) {
      printRef.current.bind.viewModel.templateOptions.title = title;
    }
  }, [title, printRef]);
  const handleBackToExport = (e) => {
    if (showEmailForm.current) {
      showEmailForm.current.style.display = 'none';
    }
    if (printRef.current) {
      printRef.current.style.display = 'block';
    }
    if (showEmailButtons.current) {
      showEmailButtons.current.classList.add('hidden-important');
    }

  };
  return (
    <>

      <div className="" id="printDiv" ref={printRef} />
      {showEmailForm && (
        <div className="Mail-form mb-4 printMailRowScroll" style={{ display: 'none' }} ref={showEmailForm}>
          <form>
            <div className="form-group printRow">
              <div className="printColLabel">
                <span className="text-danger d-inline">*</span>{" "}
                <label className="mb-2">{t("printTo")}</label>
              </div>
              <div className="printColContent">
                <input
                  className="form-control mailFormColorFl"
                  type="text"
                  id="export_txtToMail"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
                {errors.emailTo && (
                  <div className="text-danger">{errors.emailTo}</div>
                )}
              </div>
            </div>
            <div className="form-group printRow">
              <div className="printColLabel">
                <span className="text-danger d-inline">*</span>{" "}
                <label className="mb-2">{t("subject")}</label>
              </div>
              <div className="printColContent">
                <input
                  type="text"
                  onChange={(e) => setSubject(e.target.value)}
                  className="form-control mailFormColorFl"
                  value={subject}
                />
                {errors.emailSub && (
                  <div className="text-danger">{errors.emailSub}</div>
                )}
              </div>
            </div>
            <div className="form-group last printRow">
              <div className="printColLabel">
                <label className="mb-2">{t("message")}</label>
              </div>
              <div className="printColContent">
                <textarea
                  placeholder={t("typeAMessage")}
                  onChange={(e) => setMessage(e.target.value)}
                  className="form-control form-area customtextarea mailFormColorFl"
                  value={message}
                ></textarea>
              </div>
            </div>
          </form>
        </div>




      )}
      {showEmailForm && (
        <div ref={showEmailButtons} className="d-flex justify-content-between align-items-center hidden-important">
          <div className="" id="backtoex" onClick={handleBackToExport}>
            <MdOutlineKeyboardBackspace
              className="icon me-1"
              color="#33a496"
              size={20}
            />
            {t("back")}
          </div>
          <div className="mail-btns">
            <input
              type="button"
              value={t("send")}
              disabled={printisDisabled}
              onClick={sendEmail}
              className="btn-primary btn w-100"
            />
          </div>
        </div>
      )}
    </>



  );
};

export default PrintMap;
